module.exports = __webpack_public_path__ + "img/feature_a02.4cfc2aac.svg";